import React, { useEffect, useState } from "react";
import PaymentOptions from "./delivery-charge-settings/PaymentOptions";
import DeliveryOptions from "./delivery-charge-settings/DeliveryOptions";
import TwoWheeler from "./delivery-charge-settings/TwoWheeler";
import FourWheeler from "./delivery-charge-settings/FourWheeler";
import { Form, Formik } from "formik";
import Button from "@components/button";
import { useParams, useNavigate } from "react-router-dom";
import ZoneApi from "@apis/zone";

const ZoneWiseDeliverySettings = () => {
  const params: any = useParams();
  const navigate = useNavigate();
  const [initialValues, setInitialValues] = useState({
    paymentOptions: [],
    deliveryOption: "fixed",
    twoWheeler: {
      isActive: true,
      salary: 0,
      hasIncentive: false,
      incentives: [],
      slots: [
        {
          timeSlot: "",
          price: 0,
          minCharge: 0,
          perKm: 0,
          maxCharge: 0,
        },
      ],
    },
    fourWheeler: {
      isActive: true,
      salary: 0,
      hasIncentive: false,
      incentives: [],
      slots: [
        {
          timeSlot: "",
          price: 0,
          minCharge: 0,
          perKm: 0,
          maxCharge: 0,
        },
      ],
    },
  });

  const [viewMode, setViewMode] = useState("fixed");

  useEffect(() => {
    if (params?.zoneId) {
      ZoneApi.getCharges({ id: params.zoneId })
        .then((res: any) => {
          if (res?.zoneId) {
            const { twoWheeler, fourWheeler, deliveryOption, paymentOptions } =
              res;

            const cleanData = (data: any) => {
              if (!data) return undefined;
              // Remove deprecated 'incentive' field
              const { incentive, ...rest } = data;
              return {
                ...rest,
                hasIncentive: rest.hasIncentive ?? false,
                incentives: rest.incentives || [],
              };
            };

            setInitialValues((prev) => ({
              ...prev,
              ...(deliveryOption && { deliveryOption }),
              ...(paymentOptions && { paymentOptions }),
              ...(twoWheeler && {
                twoWheeler: { ...prev.twoWheeler, ...cleanData(twoWheeler) },
              }),
              ...(fourWheeler && {
                fourWheeler: { ...prev.fourWheeler, ...cleanData(fourWheeler) },
              }),
            }));
            if (deliveryOption) setViewMode(deliveryOption);
          }
        })
        .catch((err) => console.error(err));
    }
  }, [params.zoneId]);

  const handleSubmit = async (values: typeof initialValues) => {
    if (!params?.zoneId || params.zoneId === "undefined") return;
    try {
      await ZoneApi.updateCharges({ id: params.zoneId, data: values });
      navigate(-1);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({ values }) => (
        <Form>
          <PaymentOptions />
          <DeliveryOptions viewMode={viewMode} setViewMode={setViewMode} />
          <TwoWheeler viewMode={viewMode} />
          <FourWheeler viewMode={viewMode} />
          <br />
          <Button type="submit" title="Submit" />
        </Form>
      )}
    </Formik>
  );
};
export default ZoneWiseDeliverySettings;
